var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcPause48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.424 8h5.152A2.424 2.424 0 0 1 21 10.424v27.152A2.424 2.424 0 0 1 18.576 40h-5.152A2.424 2.424 0 0 1 11 37.576V10.424A2.424 2.424 0 0 1 13.424 8zm16 0h5.152A2.424 2.424 0 0 1 37 10.424v27.152A2.424 2.424 0 0 1 34.576 40h-5.152A2.424 2.424 0 0 1 27 37.576V10.424A2.424 2.424 0 0 1 29.424 8z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPause48);
export default __webpack_public_path__ + "static/media/ic-pause-48.343750af.svg";
export { ForwardRef as ReactComponent };